import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { CardsOrientation } from '../enums/cards-orientation.enum';

@Directive({
    selector: '[cardListOrientation]'
})
export class CardListOrientationDirective implements OnInit {
    @Input('cardListOrientation') public cardOrientation: CardsOrientation;

    constructor(private renderer: Renderer2, private hostElement: ElementRef) {

    }

    ngOnInit(): void {
        this.renderer.removeClass(this.hostElement.nativeElement, 'vertical');
        this.renderer.removeClass(this.hostElement.nativeElement, 'horizontal');
        this.renderer.removeClass(this.hostElement.nativeElement, 'wrapped');

        this.renderer.addClass(this.hostElement.nativeElement, this.cardOrientation == CardsOrientation.HORIZONTAL ? 'horizontal' : (this.cardOrientation == CardsOrientation.VERTICAL ? 'vertical' : 'wrapped'));
    }
}


// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/card-list/directives/card-list-orientation.directive.ts